/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { createAction } from ".";
import { User } from "../../models/User.model";
import { UserData } from "../../models/UserData.model";
import { Customer } from "../../types/Customer";
import { Quotation } from "../../types/Quotation";
import { Me } from "../../types/RootState";

export const ME_SET_USER_ACTION = "me.setUser";
export const ME_SET_USER_DATA_ACTION = "me.setUserData";
export const ME_SET_SYNCHRONIZED_USER_DATA_ACTION = "me.setSynchronizedUserData";
export const ME_SET_CUSTOMER_ACTION = "me.setCustomer";
export const ME_SET_CUSTOMER_QUOTATION_ACTION = "me.setCustomerQuotation";
export const ME_UPDATE_USER_ACTION = "me.updateUser";
export const ME_UPDATE_USER_GO_HOME_ACTION = "me.updateUserAndGoHome";
export const ME_RESET_ACTION = "me.reset";
export const ME_GET_ADVISORS_STATS_ACTION = "me.getAdvisorsStats";
export const ME_SET_ADVISORS_STATS_ACTION = "me.setAdvisorsStats";
export const ME_STARTUP_NOTIFICATIONS_ACTION = "me.startupNotificationsForMe";

export const getAdvisorsStats = createAction(ME_GET_ADVISORS_STATS_ACTION);

export const setUser = createAction<User>(ME_SET_USER_ACTION);
export const setAdvisorsStats = createAction<Me["advisorsStats"]>(ME_SET_ADVISORS_STATS_ACTION);
export const setUserData = createAction<UserData>(ME_SET_USER_DATA_ACTION);
export const setSynchronizedUserData = createAction<{ userData: UserData; beforeTimestamp: string }>(
    ME_SET_SYNCHRONIZED_USER_DATA_ACTION
);
export const updateUser = createAction<User>(ME_UPDATE_USER_ACTION);
export const updateUserAndGoHome = createAction<User>(ME_UPDATE_USER_GO_HOME_ACTION);
export const setCustomer = createAction<Customer>(ME_SET_CUSTOMER_ACTION);
export const setCustomerQuotation = createAction<{ customerId: string; quotation: Quotation }>(
    ME_SET_CUSTOMER_QUOTATION_ACTION
);

export const startupNotificationsForMe = createAction<{}>(ME_STARTUP_NOTIFICATIONS_ACTION);
export const resetMe = createAction<{}>(ME_RESET_ACTION);



// WEBPACK FOOTER //
// ./src/store/actions/me.actions.ts